const pageTitle = (pageTitle = null, action) => {
  switch (action.type) {
    case 'SET_PAGE_TITLE':
      return action.payload
    default:
      return pageTitle
  }
}
export default pageTitle
